export default {
  FAQ_PAGE_HEADING: `FAQ & Troubleshooting`,
  COLLAPSE_FAQ_LABEL_TEXT: `Collapse FAQ`,
  EXPAND_FAQ_LABEL_TEXT: `Expand FAQ`,
  FAQ_SPEAKERS_HEADING: `Troubleshoot your speakers`,
  FAQ_MICROPHONE_HEADING: `Troubleshoot your microphone`,
  FAQ_CAMERA_HEADING: `Troubleshoot your camera`,
  FAQ_STILL_HAVE_QUESTIONS: `Still have questions? Please contact your practice.`,

  WHAT_IS_A_TELEHEALTH_APPT_HEADING: `What is a telehealth appointment?`,
  WHAT_IS_A_TELEHEALTH_APPT_CONTENT: `
    <p>
      A telehealth appointment is an online video or telephone call with your provider to figure out your healthcare
      needs and next steps. Online appointments let you speak with your provider without needing to leave your home.
    </p>
    <p>
      They’re convenient, they save time, and they help keep patients and staff safe during a crisis (like a
      natural disaster or a pandemic). Telehealth visits can cover a wide range of needs: mental health, chronic
      disease follow-ups, rashes, and more.
    </p>
    <p>
      To have a telehealth appointment, you need a smartphone, tablet, or computer. It should have internet access and
      video. This can be a built-in camera and microphone or separate equipment that you plug in.
    </p>`,

  HOW_DO_I_PREPARE_HEADING: `How do I prepare for my appointment?`,
  HOW_DO_I_PREPARE_CONTENT: `
    <p>Before your appointment, get your equipment ready:</p>
    <p>Make sure your computer, tablet, or smartphone has all of these:</p>
    <2>
        <0>An internet connection</0>
        <1>A camera and microphone</1>
        <2>One of the web browsers that works with athenaTelehealth (listed below)</2>
        <3>Check that everything is set up:</3>
        <4>
            <0>Make sure that your camera, microphone, and speakers are working (use our quick <2>pre-call device check</2>
                ).</0>
            <1>Turn off any apps you’re not using to free up bandwidth and memory for better call quality.</1>
        </4>
        <5>Find the best location for your call:</5>
        <6>
            <0>Find a quiet space where you will feel OK talking about concerns with your provider.</0>
            <1>Turn on the lights in the room or sit near a window so your provider can see you clearly.
            </1>
            <2>If you’re on a mobile device, make sure your camera is facing you. Hold your phone at eye level during
                your call. You can also prop your phone up to be hands-free.</2>
        </6>
    </2>
    <p>You should also have these on hand:</p>
    <4>
        <0>Your updated insurance information</0>
        <1>A form of payment</1>
        <2>Any questions for your provider</2>
        <3>Your current list of medications (you could even get the bottles out and have them nearby)</3>
    </4>
    <p>Plan to join your appointment call 5-10 minutes before your scheduled time to check your connection
        and make sure everything is ready for when your provider joins.</p>`,

  WHICH_BROWSERS_CAN_I_USE_HEADING: `Which web browsers can I use for my appointment?`,
  WHICH_BROWSERS_CAN_I_USE_CONTENT: `
            <p>These browsers work with the athenaTelehealth app:</p>
            <1>
                <0>Desktop</0>
            </1>
            <2>
                <0>Google Chrome (latest 3 versions) for macOS and Windows</0>
                <1>Safari (version 12 and later) for macOS</1>
                <2>Firefox (latest three versions) for macOS and Windows</2>
            </2>
            <3>
                <0>Mobile</0>
            </3>
            <4>
                <0>Google Chrome (latest 3 versions) for Android</0>
                <1>Samsung Browser (version 12 and later) for Android</1>
                <2>Google Chrome (latest 3 versions) for iOS</2>
                <3>Safari (version 12 and later) for iOS (Important: athenaTelehealth is not supported on other iOS browsers, such
                    as Firefox)</3>
            </4>`,

  INTERNET_SPEED_HEADING: `Will my internet speed affect my call quality? What can I do to make it better?`,
  INTERNET_SPEED_CONTENT: `
    <p>Internet speed can affect overall call quality. However, you can take some steps to make sure you get
      as much internet access as possible during your call:</p>
    <1>
      <0>Shut down any other apps on your device. Close other browser tabs and windows.</0>
      <1>
          <0>These might be taking up internet bandwidth and memory on your device.</0>
          <1>This includes unused apps, background apps, and streaming apps like Netflix or YouTube.</1>
      </1>
      <2>Disable low power mode on battery-powered devices. Plug the device in to charge to get out of low power mode.</2>
      <3>
          <0>Low power mode may turn off some features on your device and cut down how well it performs, which can affect
              your call.</0>
      </3>
      <4>If other people in your household are also using the internet, see if they can stop while you make
          your call.</4>
    </1>
    <p>You can also try contacting your internet service provider.</p>
    <3>
      <0>They may be able to help fix your problems. They might also have different options for getting faster
          connections.</0>
      <1>Because of COVID-19, some internet companies are slowing down internet traffic on purpose during high demand
          hours. This helps with connection problems while so many people are streaming videos at home. If you think this
          is happening to you, ask your internet service provider to allow normal traffic to Athena.io because you are
          using it to get healthcare.</1>
    </3>`,

  WHERE_IS_MY_LINK_HEADING: `Where is my appointment link?`,
  WHERE_IS_MY_LINK_CONTENT: `
    <p>
      Your appointment link will be in the emails that your practice sends you (to confirm your appointment and remind
      you about it). In the email message, click the blue button that says “YOUR APPOINTMENT LINK” OR
      “GO TO APPOINTMENT.” If you can’t find these emails, check your “spam” or “junk” email folders.
    </p>
    <p>Your practice will also text the link to your smartphone as a reminder.</p>
    <p>If you can’t find the link, you can ask the practice to send it to you again.</p>
    <p>
      Make sure that your practice has your up-to-date contact details, including email address and phone number. If
      you use a patient portal website to contact your practice, make sure that your email and phone number are
      updated there, too.
    </p>`,

  WHEN_SHOULD_I_JOIN_HEADING: `When should I join my call?`,
  WHEN_SHOULD_I_JOIN_CONTENT: `
    <p>
      Join your call 5-10 mins before your scheduled time to check your connection and make sure
      everything is ready for when your provider joins.
    </p>
    <p>
      Your appointment link will only work on the day of your appointment. If you want to test the link, you can do
      this on the same day of your appointment.
    </p>
    <p>
      Each appointment will get its own separate link, even if you have more than one appointment on the same day. Be
      sure to use the right link to get into the right appointment.
    </p>`,

  WHAT_SHOULD_I_DO_WHEN_JOIN_HEADING: `What should I do when I join the call?`,
  WHAT_SHOULD_I_DO_WHEN_JOIN_CONTENT: `
    <p>
      When you join the call, you will be in a private virtual “waiting room.” Please sit tight until a
      member of your care team joins.
    </p>
    <p>
      Don’t start using other apps that use your camera, microphone, or speakers. This could prevent you from
      hearing when someone else joins.
    </p>
    <p>
      Your provider’s schedule may be very unpredictable these days, so thank you for your patience while you
      wait!
    </p>`,

  IS_MY_CALL_SECURE_HEADING: `Is my athenaTelehealth call private and secure?`,
  IS_MY_CALL_SECURE_CONTENT: `
    <p>Yes, athenaTelehealth calls are private and secure. The app is HIPAA compliant.</p>
    <p>
      Every online appointment gets a unique link. The links are never reused or copied, and they are never
      accessible to anyone else.
    </p>`,

  WHY_CANT_SEE_SELF_HEADING: `Why can’t I see myself?`,
  WHY_CANT_SEE_SELF_CONTENT: `
    <p>Another app might be using your camera. Try shutting down all other apps or restarting your device, and then rejoin
      your call. This should free up your camera for use.</p>
    <1>Your camera may also be blocked or disabled. To make sure your device is set up for a successful call, go through our
      simple <1>pre-call device check.</1>
    </1>`,

  CANT_HEAR_PROVIDER_HEADING: `I can’t hear my provider. What should I do?`,
  CANT_HEAR_PROVIDER_CONTENT: `
    <p>Make sure your device volume is up and that you don’t have the sound on mute.</p>
    <p>If you have headphones or other speakers connected, check to see if the sound is playing there.</p>
    <2>If you’re using Bluetooth speakers, first check that your device and speakers have been set up as a pair. If they are
        already paired, make sure that Bluetooth is switched to “on” on your device. To make sure your device is set up for
        a successful call, go through our simple <2>pre-call device check.</2>
    </2>`,

  PROVIDER_CANT_HEAR_ME_HEADING: `My provider can’t hear me. What should I do?`,
  PROVIDER_CANT_HEAR_ME_CONTENT: `
    <p>Check your sound and equipment:</p>
    <1>
        <0>Make sure you’re not on mute.</0>
        <1>
            <0>If you’re on an Android device and this is your first call, you will need to mute and unmute at the start of
                the call. Your browser will show you a permission check for your camera and microphone. After you
                give that permission, you will be set and won’t have to do this again.</0>
        </1>
        <2>Check that your internet connection is working.</2>
        <3>If you’re on a mobile device, make sure you’re connected to WiFi.</3>
        <4>See if your microphone is blocked or disabled and try enabling it.</4>
        <5>If you’re using headphones or a headset, disconnect them and use your device’s speakers and microphone instead.
        </5>
        <6>If you’re using a Bluetooth headset, you may need to disable Bluetooth as well.</6>
    </1>
    <p>If that didn’t fix the problem, try checking your device itself:</p>
    <3>
        <0>Shut down any other apps. Close other browser tabs and windows.</0>
        <1>They may be using the microphone. They may also be taking up internet bandwidth and memory on your device.</1>
        <2>This includes unused apps, background apps, and streaming apps like Netflix or YouTube.</2>
        <3>Check that your browser isn’t in private mode or an incognito window.</3>
        <4>Disable low power mode on battery-powered devices. Plug the device in to charge to get out of low power mode.</4>
        <5>Restart your device to close down any other apps that are using up power.</5>
    </3>
    <p>Your internet connection could also be causing problems. Try these steps:</p>
    <5>
        <0>If you’re on a WiFi connection, move closer to the router.</0>
        <1>If your router is in a cupboard or far away from your device, consider moving it to a central location in your
            home for better overall signal.</1>
        <2>You can also try switching to the 5GHz frequency to increase the bandwidth available to your device.</2>
        <3>Other devices close to your router could also disrupt your signal. Consider moving those further away.</3>
        <4>If other people in your household are also using the internet, see if they can stop while you make your call.</4>
        <5>Use an ethernet cable to directly connect to your router instead of using WiFi for a more stable connection.</5>
        <6>Contact your internet service provider. They may be able to help troubleshoot problems and offer different
        options for faster connection if your signal strength is fine but your speed is slow.</6>
        <7>Because of COVID-19, some internet companies are slowing down internet traffic on purpose during high demand
            hours. This helps with connection problems while so many people are streaming videos at home. If you think this
            is happening to you, ask your internet service provider to allow normal traffic to Athena.io because you are
            using it to get healthcare.</7>
    </5>
    <6>To make sure your device is set up for a successful call, go through our simple <1>pre-call device check.</1>
    </6>`,

  I_GOT_DISCONNECTED_HEADING: `I started my call but I got disconnected. What should I do?`,
  I_GOT_DISCONNECTED_CONTENT: `<p>If you get disconnected, simply refresh the page and rejoin your call.</p>`,
};
